



















































import { Component, Vue } from 'nuxt-property-decorator';
import { mapState } from 'vuex';

import SignUpSocialButtons from './SignUpSocialButtons/SignUpSocialButtons.vue';
import SignUpForm from './SignUpForm/SignUpForm.vue';
import { NUMBER_OF_USERS } from './constants';
import ModalBlack from './ModalBlack/ModalBlack.vue';
import { isUserInsideExternalApp } from '~/utils/externalRedirections';
import Modal from '~/components/common/Modal/Modal.vue';

@Component<SignUpModal>({
  name: 'SignUpModal',
  components: {
    Modal,
    ModalBlack,
    SignUpSocialButtons,
    SignUpForm,
  },
  computed: {
    ...mapState(['promo']),
  },
})
export default class SignUpModal extends Vue {
  isUserInsideExternalApp: boolean = false;
  isLoading: boolean = false;
  NUMBER_OF_USERS: string = NUMBER_OF_USERS;
  promo!: string;

  get referer(): string {
    const { query } = this.$route;
    return (query?.refferer || query?.referer) as string;
  }

  get loginParams() {
    return {
      ...(this.promo && { promo: this.promo }),
      auth_source: 'sign-up-modal',
    };
  }

  mounted() {
    this.isUserInsideExternalApp = isUserInsideExternalApp(
      document.referrer,
      navigator.userAgent,
      this.$device.isWebView,
    );
  }

  onSocialLogin(provider: 'google' | 'linkedin') {
    this.$analytics.logEvent(`global__war-room-sign-up-modal__${provider}-button__click`);
  }

  navigateToSignIn() {
    this.$analytics.logEvent('global__war-room-sign-up-modal__login-link__click');
    this.$modal.showWithRoute('SIGN_IN_MODAL');
  }
}
